import { Component, Input, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { IntakeService } from '../../services/intake.service';
import { Session } from '../../services/session.service';
import { ConfigurationService, InpageAliasService } from '../..';
import { TranslationRequest } from 'src/app/shared/models/translation/translation-request';
import { Aliases } from '../../models/aliases';

@Component({
    selector: 'app-report-new-claim',
    template: `
    @if (isBusy) {
      <mat-spinner
        color="accent"
        diameter="40"
        mode="indeterminate"
      ></mat-spinner>
    }
    <div class="overlay">
      <div mat-dialog-title class="dialog-container tw-flex ">
        <app-action-row>
          <h2 left1 class="app-header-2 heading-popup">{{ title | translation: translationRequest }}</h2>
          <div right1>
            <button
              mat-icon-button
              (click)="closeModalPopUp()"
              [attr.aria-label]="'ariaLabelMessage' | translation: translationRequest"
              tabindex="0"
              class="closebtn"
              alt="close"
              title="close"
              >
              <mat-icon>clear</mat-icon>
            </button>
          </div>
        </app-action-row>
      </div>
      <mat-dialog-content class="modal-body fltleft">
        <div>
          <p>{{ callout | translation: translationRequest }}</p>
        </div>
      </mat-dialog-content>
    
      <mat-dialog-actions align="end" class="mySedwick-popupFooter">
        <app-button
          mat-button
          alt="Cancel and go back"
          [mat-dialog-close]="true"
          emphasis="Low"
          (click)="closeModalPopUp()"
          class="app-pr2"
          label="Back"
          >
        </app-button>
        <app-button
          mat-button
          alt="Continue to Report a Claim"
          [mat-dialog-close]="true"
          emphasis="High"
          (click)="redirectToSmartly()"
          label="Continue"
          >
        </app-button>
      </mat-dialog-actions>
    </div>
    `,
    styles: [
        `
      .titleheading {
        color: #171c20 !important;
      }
      .close.mat-button {
        float: right;
        position: relative;
        color: #67707a;
      }
      .modal-body {
        height: 200px;
      }
      .pad-right-5 {
        padding-right: 2em;
      }
      .closepnl {
        float: left;
        text-align: right;
      }
      .fltleft {
        float: left;
      }
      .continuebtn {
        background-color: #007dbc !important;
        color: #fff;
      }
      .continuebtn:hover {
        background-color: #035e81 !important;
      }
      .closebtn {
        background-color: #ffffff !important;
        color: #3f464d;
        border: 1px solid #3f464d;
      }
      .closebtn:hover {
        background-color: #f1f4f7 !important;
      }
      .roundbtn {
        border-radius: 24px;
      }

      ::ng-deep .cdk-overlay-pane {
        max-width: 60vw !important;
      }

      @media (max-width: 667px) {
        ::ng-deep .tw-flex-wrap {
          flex-wrap: nowrap;
        }
        ::ng-deep .tw-pr-2 {
          padding-right: 0.3rem;
        }
      }
      @media (max-width: 600px) {
        ::ng-deep .mdc-dialog__title {
          padding-left: 1px !important;
        }
      }
    `,
    ],
    standalone: false
})
export class ReportNewClaimComponent implements OnInit {
  translationRequest = new TranslationRequest({
		language: sessionStorage.getItem('languagepreference'),
		key: null,
		contNum: 0,
		tableName: null,
		primaryKey: null,
		primaryValue: null,
		lob: null,
		group: 'Shared',
		subGroup: 'Shared',
	  });

  title: string = 'Confirmation';
  reportClaimLabel: Aliases = { value: 'report a claim', key: 'ReportClaim', isOverride: false } as Aliases;
  callout: string;
  isBusy: boolean = false;
  constructor(
    public dialogRef: MatDialogRef<ReportNewClaimComponent>,
    private intakeService: IntakeService,
    public session: Session,
    public claimConfigService: ConfigurationService,
    public inpageAliasService: InpageAliasService
  ) {}

  async ngOnInit() {
    this.reportClaimLabel = await this.inpageAliasService.replaceAliases(
      'ReportClaim',
      this.claimConfigService.GetConfig.configFeatures.aliases
    );

    this.callout = this.inpageAliasService.composeSentence([
      'You are about to open a new tab (or window) to',
      { alias: this.reportClaimLabel },
    ]) + `. Ensure that any Popup Blockers are disabled.
    Refer to browser or device documentation for more information. You can either proceed or cancel this action using the buttons below.`;
  }
  closeModalPopUp() {
    this.dialogRef.close();
  }

  async redirectToSmartly() {
    this.isBusy = true;

    const response = await this.intakeService.getSmartlyUrl();
    window.open(response.url, '_blank');
  }
}
